/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green = front-running finish, red = back of grid or DNF`)
};

const es_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = llegada al frente, rojo = fondo de parrilla o DNF`)
};

const de_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grün = Spitzenposition, Rot = hinteres Feld oder DNF`)
};

const nl_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groen = finishen aan de kop, rood = achteraan of DNF`)
};

const fr_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vert = arrivée en tête, rouge = fond de grille ou DNF`)
};

const it_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = arrivo nelle prime posizioni, rosso = fondo griglia o DNF`)
};

const pt_br2_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = chegada na frente, vermelho = fundo do grid ou DNF`)
};

const pt_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = posição da frente, vermelho = fundo da grelha ou DNF`)
};

const ja_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリーン = 上位フィニッシュ、レッド = 下位またはDNF`)
};

const zh_f1_profile_tooltip_finish_heatmap = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绿色 = 靠前完赛，红色 = 靠后或退赛`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_finish_heatmap = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_finish_heatmap(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_finish_heatmap", locale)
	if (locale === "en") return en_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "es") return es_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "de") return de_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "it") return it_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_finish_heatmap(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_finish_heatmap(inputs)
	return zh_f1_profile_tooltip_finish_heatmap(inputs)
};